let uploadedCoverFile = [];
let uploadedCoverFile2 = [];
let cover_post_list = '';
let coverInchToPx = 300;
let coverCmToPx = 120;
var cover_picker;
var albumSpreads = parseInt($("select#SingleOptionSelector-0").find("option:selected").text());   
if( albumSpreads == 5) { var albumCoverWidthPx = 3646; }
if( albumSpreads == 10) { var albumCoverWidthPx = 3694; }
var albumCoverHeightPx = 1800;





/*
var $n = jQuery.noConflict();
$n("body").on('change', '.dd_1045850_426629', function(e){
  alert('jest:');
});  
*/





var $j = jQuery.noConflict();
$j(document).ready(function() { 

 

 
	$j("body").on('change', '.mango-cover-uploader-wrapper #step-2-confirmation input[type="checkbox"]', function(e){
		var checked = $j(this).prop('checked');
		if(checked == true) {
			$j(".mango-cover-uploader-wrapper #go-to-finish").show();
		} else {	
			$j(".mango-cover-uploader-wrapper #go-to-finish").hide();
		}   
    });  
  	$j(".mango-cover-uploader-wrapper #go-to-finish").click(function(){
		finishCoverUploader();
    });  
    $j("body").on('click', ".mango-cover-uploader-wrapper button.close", function(e){
		closeCoverUploader();    
    });
    $j("body").on('click', ".mango-cover-uploader-wrapper button.close2", function(e){
		closeCoverPreview();    
    });  
    $j("body").on('click', ".mango-cover-uploader-wrapper #step-2-cancel", function(e){
		closeCoverUploader();
    });  

    $j("select#SingleOptionSelector-0").on('change', function() {
        albumSpreads = parseInt( $j(this).find("option:selected").text() );    
        if( albumSpreads == 5) { albumCoverWidthPx = 3646; }
        if( albumSpreads == 10) { albumCoverWidthPx = 3694; }
    });  

    $j("#btn-remove-files").click(function(){
		$j("#file-upload-show-spreads-btn").hide();           
		$j("#file-upload-show-btn").show();    
		closePreview();         
		$j( "#mango-uploader-files" ).val('');
		$j( "#mango-uploader-files-names" ).val('');     
        $j( "#mango-uploader-preview-slider2 .item" ).remove();    
        $j("#message-no-uploader-files").show();        
    });



    $j("#file-cover-upload-show-btn").click(function(){
        $j( "#mango-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-cover-uploader-preview-slider .item" ).remove();  
        $j( "#mango-cover-uploader-preview-slider2 .item" ).remove();        
        $j(".label-album-size").text(albumCoverWidthPx + 'x' + albumCoverHeightPx);      
     
		const cover_filestack_client = filestack.init('AbkDGv2FYSHi0mxqhYMgQz'); 
        const cover_options = {
        	displayMode: 'inline',
        	container: '#coverdroppane',    
  			accept: ["image/jpeg", "image/jpg"],          
			fromSources: ["local_file_system","googledrive","onedrive"],
			exposeOriginalFile: true,          
          	maxFiles: 1,
          	minFiles: 1,          
            transformations: {
               crop: {
                    aspectRatio: albumCoverWidthPx/albumCoverHeightPx,
                    force: true
                },
           		circle: false,
           	 	rotate: false
            },
			customText: {                     
        		'Our file upload limit is {maxFiles} {filesText}': 'You selected the wrong number of files. The number of files must be equal to the number of spreads selected.'
            },
            onFileUploadFinished: function(file) {
//		console.log(file);              
				uploadedCoverFile.push(file["url"]);
				uploadedCoverFile2.push(file["filename"] +'^'+file["handle"]);          
            },          
       	 	onUploadDone: function(){
              	uploadedCoverFile2.sort();
   				uploadCoverFinished(uploadedCoverFile2);
              	// send tokens to helper
              	$j.each( uploadedCoverFile2, function( key, value ) {
					post_list = post_list + value +',';
				});
              	var post_list_data = { 
                  	hash : $j( "#mango_post_list_data_hash" ).val(),
                    files : post_list,
                  	source : 'qtalbumseu'
                };
                $j.ajax({
					type: "POST",
					url: "https://filestack.qtalbums.ovh/token_to_db.php",
					headers: { 'Content-Type': 'application/x-www-form-urlencoded'},                  
					data: post_list_data,
					success: function(msg){
					console.log(msg);  
                 }
				});      
              	// end sending
  			},      
          	//onFileSelected: checkCoverImgSize,  
          	onClose: function(){
            },      
            uploadConfig: {
				tags: {
					"foo": "bar"
				},

			},   
        };
      	cover_picker = cover_filestack_client.picker(cover_options);
      
		$j(".mango-cover-uploader-wrapper").show();
		$j("#mango-cover-uploader-modal").show();
      	$j("#mango-cover-uploader-step-1").show();
		$j("#mango-cover-uploader-step-2").hide();            
		cover_picker.open();  
		window.scrollTo(0, 0);         
    });
  
  

    function closeCoverUploader(){
		$j(".mango-cover-uploader-wrapper").hide();
		$j("#mango-cover-uploader-modal").hide();
		$j("#mango-cover-uploader-step-1").hide();            
      	$j("#mango-cover-uploader-step-2").hide();     
		$j("#mango-cover-uploader-step-3").hide();       
        $j("#mango-cover-uploader-files").val('');
		$j("#mango-cover-uploader-files-names").val('');        
      	cover_picker.close();      
       uploadedCoverFile = [];
       uploadedCoverFile2 = [];      

        $j( "#mango-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-cover-uploader-preview-slider .item" ).remove();  
        $j( "#mango-cover-uploader-preview-slider2 .item" ).remove();        
    }
    function closeCoverPreview(){
		$j(".mango-cover-uploader-wrapper2").hide();
		$j("#mango-cover-uploader-modal2").hide();
		$j("#mango-cover-uploader-step-4").hide();
    }  
    function finishCoverUploader(){
		$j(".mango-cover-uploader-wrapper").hide();
		$j("#mango-cover-uploader-modal").hide();
		$j("#mango-cover-uploader-step-1").hide();            
      	$j("#mango-cover-uploader-step-2").hide();       
		$j("#file-cover-upload-show-btn").hide();    
		$j("#file-cover-preview").show();        
      	cover_picker.close();
 uploadedCoverFile = [];
 uploadedCoverFile2 = [];   
   
      	$j( "#mango-cover-uploader-preview-order .item" ).remove();        
        $j( "#mango-cover-uploader-preview-slider .item" ).remove();       
		$j("#go-to-finish").hide();       
        $j("#message-no-uploader-files").hide();         
    }
  
    function uploadCoverFinished(upfiles){
//		console.log(upfiles);
		$j("#mango-cover-uploader-step-1").hide();            
      	$j("#mango-cover-uploader-step-2").show();                   
        //var albumSpreads = parseInt($("select#SingleOptionSelector-0").find(":selected").text());    
        $.each( upfiles, function( key, value ) {
            var temp_array = value.split('^');
            var filename = temp_array[0];              
            var handle = temp_array[1];            
            $j( "#mango-cover-uploader-preview" ).append( '<img src="https://cdn.filestackcontent.com/resize=width:1800/' + handle + '" alt="" />');              		
            $j( "#mango-cover-uploader-file" ).val( $( "#mango-cover-uploader-file" ).val() +  handle + ';' );       
            $j( "#file-cover-preview  " ).append( '<img src="https://cdn.filestackcontent.com/resize=width:900/' + handle + '" alt="" style="width:100%;height:auto;"/>');        
            
            var image_width = $j( "#mango-cover-uploader-preview img" ).width();
            var spine_width = (image_width/albumCoverWidthPx) * (albumCoverWidthPx-3600);
            $j( "#mango-cover-uploader-preview" ).append( '<div class="mango-cover-uploader-preview-line" style="transform:translateX(-'+ Math.round((spine_width/2)+1) +'px)"><div/>');  
            $j( "#mango-cover-uploader-preview" ).append( '<div class="mango-cover-uploader-preview-line" style="transform:translateX('+ Math.round((spine_width/2)+1) +'px)"><div/>');     


          
          // recalculate after window resize
        });
    }
  
    function checkCoverImgSize(thisfile) {
        return new Promise(function (resolve, reject) {
          const minWidth = albumCoverWidthPx * 1;
          const minHeight = albumCoverHeightPx * 1;
          const blob = thisfile.originalFile;
          const url = window.URL.createObjectURL(blob);
          const img = new Image();
          img.src = url;

          img.onload = function () {
            window.URL.revokeObjectURL(url);
            //alert( this.naturalWidth +'---'+this.naturalHeight);
            if (this.naturalWidth < minWidth) {
              reject('Image quality ('+thisfile.filename+') is to poor (width). Minimal image dimentions are ' + minWidth + 'x' + minHeight + 'px');
              cover_picker.cancel();    
            }
            else if (this.naturalHeight < minHeight) {
              reject('Image quality ('+thisfile.filename+') is to poor. Minimal image dimentions are  ' + minWidth + 'x' + minHeight + 'px');
            }
            var ratio_natural = this.naturalWidth / this.naturalHeight;
            var ratio = minWidth/minHeight;            
            var ratio_min = ((minWidth/minHeight) - 0.01);
            var ratio_max = ((minWidth/minHeight) + 0.01);  
             
            if ( (ratio_natural.toFixed(2) < ratio_min.toFixed(2)) || (ratio_natural.toFixed(2) > ratio_max.toFixed(2)) ) {
              reject('WRONG DESIGN DIMENSIONS. You have uploaded '+this.naturalWidth+'x'+this.naturalHeight+'px while we need '+minWidth+'x'+minHeight+'px or bigger but with the same proportions.');
            }
            resolve();
          }
        });
    }
});
